export const TICK_RATE = 60;
export const DT = 1 / TICK_RATE;
export const MAX_PLAYERS = 12;
export const TEAM_SIZE = 6;
export const MAX_ENTITIES = 2048;
export const GRAVITY = 20;

/** Lag compensation: max rewind the server will honour. */
export const MAX_REWIND_MS = 200;
export const MAX_REWIND_TICKS = Math.round((MAX_REWIND_MS / 1000) * TICK_RATE);
/** How many ticks of hitbox history the server keeps (rewind cap + interpolation slack). */
export const HISTORY_TICKS = MAX_REWIND_TICKS + 12;

/** Remote entities are rendered this many ticks behind the latest snapshot. */
export const INTERP_DELAY_TICKS = 3;
/** Inputs repeated per packet for loss resilience. */
export const INPUT_REDUNDANCY = 4;

export const RESPAWN_TICKS = 10 * TICK_RATE;
export const PROTOCOL_VERSION = 10;

export enum Team {
  None = 0,
  A = 1,
  B = 2,
}

export const otherTeam = (t: Team): Team => (t === Team.A ? Team.B : t === Team.B ? Team.A : Team.None);

/**
 * Kill credit, Marvel Rivals rules. Everyone who damaged the victim in the last 5 s gets a KO; the
 * killing blow is also a Final Hit. Damage never earns an assist: assists go to allies who enabled
 * the KO without earning one — healed or buffed a player who got the KO, or crowd-controlled or
 * debuffed the victim — within 5 s, or while that effect is still running.
 */
export const KO_WINDOW = 5 * TICK_RATE;
export const ASSIST_WINDOW = 5 * TICK_RATE;
